const WORKSPACE_DESTINATIONS: Record<string, string> = {
  "/performanceinsights": "/performanceDashboard",
  "/reviewandreflect": "/myPerformance",
  "/giveFeedback": "/myPerformance?view=feedback",
  "/selfCheck": "/myPerformance?view=self",
  "/myFeedback": "/myPerformance?view=results",
  "/adminDashboard": "/performanceDashboard?view=admin",
  "/pmDashboard": "/performanceDashboard?view=pm",
  "/teamSubmissions": "/performanceDashboard?view=submissions",
  "/hodDashboard": "/performanceDashboard?view=delivery",
};

export function getPerformanceLensWorkspaceDestination(path: string | undefined): string | undefined {
  return path ? WORKSPACE_DESTINATIONS[path] : undefined;
}

type PerformanceMenuItem = {
  name?: string;
  achorValue?: string;
  subMenu?: PerformanceMenuItem[];
};

export function getPerformanceLensPageName(
  menu: PerformanceMenuItem[],
  pathname: string,
  search: string,
): string | undefined {
  const workspacePath = pathname.replace(/^\/dashboard/, "");
  if (workspacePath !== "/myPerformance" && workspacePath !== "/performanceDashboard") {
    return undefined;
  }

  const menuItems = menu.flatMap((item) => [item, ...(item.subMenu ?? [])]);
  const destination = (item: PerformanceMenuItem) =>
    getPerformanceLensWorkspaceDestination(item.achorValue) ?? item.achorValue;
  const matchedItem = menuItems.find((item) => destination(item) === `${workspacePath}${search}`)
    ?? menuItems.find((item) => destination(item) === workspacePath);

  return matchedItem?.name;
}
